import { observer } from 'mobx-react';
import * as React from 'react';
export var ContractEA = observer(function (props) {
    var plan = props.plan;
    var total = plan.currentPricing.sellInc / 100;
    var discounts = plan.recurringCredits
        ? plan.recurringCredits.reduce(function (acc, discount) {
            return discount.promoCode ? acc + 0 : acc + discount.amount;
        }, 0)
        : 0;
    var totalDiscount = discounts / 100;
    var totalPrice = (total + totalDiscount).toFixed(2);
    var hasActivationFee = plan.currentPricing.customPricings['ContractActivation'] &&
        plan.currentPricing.customPricings['ContractActivation']
            .sellInc !== 0;
    var activationFeeDollarsString = hasActivationFee
        ? (plan.currentPricing.customPricings['ContractActivation']
            .sellInc / 100).toFixed(2)
        : 0.0;
    function convertToMpbs(kbps) {
        return kbps / 1024;
    }
    return (plan.code !== null && (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "pod-header" },
            React.createElement("h3", null, plan.name),
            React.createElement("p", null,
                React.createElement("strong", null,
                    "$",
                    totalPrice),
                React.createElement("br", null),
                React.createElement("small", null,
                    "Charged ",
                    plan.billingInterval))),
        React.createElement("div", { className: "pod-body" },
            React.createElement("p", { className: "small" },
                "nbn",
                convertToMpbs(plan.baseSpeedInKb),
                " Typical Evening Speed",
                ' ',
                (plan.typicalEveningSpeedInKb / 1024).toFixed(1),
                " Mbps",
                ' '),
            plan.recurringCredits &&
                plan.recurringCredits.map(function (list, index) {
                    return !list.promoCode && (React.createElement("p", { className: "small", key: index },
                        "Includes $",
                        Math.abs(list.amount / 100),
                        ' ',
                        list.numberOfCycles > 0 && !list.promoCode
                            ? " for " + list.numberOfCycles + " months (then $" + total.toFixed(2) + ")."
                            : 'per month',
                        ' ',
                        "nbn\u2122 energy bundle discount"));
                }),
            hasActivationFee && (React.createElement("p", null,
                "$", activationFeeDollarsString + " activation fee"))),
        React.createElement("div", { className: "pod-footer" },
            React.createElement("p", { className: "small" },
                React.createElement("a", { href: plan.criticalInformationSummaryUrl, target: "_blank" }, "Critical Information summary")),
            React.createElement("p", { className: "small" },
                React.createElement("a", { href: "https://www.energyaustralia.com.au/sites/default/files/2022-09/nbn%20Key%20Fact%20Sheet.pdf", target: "_blank" }, "(see our nbn\u2122 Key Facts)"))))));
});
//# sourceMappingURL=ContractEA.js.map